import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useFiliaisOuvidoriaNavegacao = () => {
  const history = useHistory();

  const handleRowClick = useCallback(
    row => {
      history.push(`/pages/filiaisouvidoria/${row.id}`);
    },
    [history]
  );

  const handleAdicionar = useCallback(() => {
    history.push('/pages/filiaisouvidoria/criar');
  }, [history]);

  const handleEditar = useCallback(
    id => {
      history.push(`/pages/filiaisouvidoria/editar/${id}`);
    },
    [history]
  );

  return {
    handleRowClick,
    handleAdicionar,
    handleEditar,
  };
};
